// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tooltip_show__X1SxV {
    visibility: visible;
    opacity: 1;
}

.Tooltip_hide__UNidW {
    visibility: hidden;
    opacity: 0;
}

.Tooltip_tooltip__3Iqb1 {
    position: relative;
    display: inline-table;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_tooltiptext__naU\\+G,
.Tooltip_tooltip__3Iqb1 .Tooltip_dangerTooltip__8v5gt {
    width: max-content;
    max-width: 250px;
    font: 100 14px/22px 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 13px;
    border-radius: 2px;
    line-height: 1.5;

    text-align: center;
    z-index: 40;
    transition: opacity 0.3s;
    margin-top: auto;
    margin-bottom: auto;
    display: inline-table;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_tooltiptext__naU\\+G::after,
.Tooltip_tooltip__3Iqb1 .Tooltip_dangerTooltip__8v5gt::after {
    content: "";
    border-width: 5px;
    border-style: solid;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_tooltiptext__naU\\+G {
    background-color: var(--color-120);
    color: var(--color-106);
}

.Tooltip_tooltip__3Iqb1 .Tooltip_dangerTooltip__8v5gt {
    background-color: var(--color-red-primary);
    color: var(--color-text-light);
}

.Tooltip_tooltip__3Iqb1 .Tooltip_tooltipContent__AfOac {
    padding: 7px 11px;
}

.Tooltip_tooltip__3Iqb1.Tooltip_auto__cAwzz .Tooltip_tooltiptext__naU\\+G,
.Tooltip_tooltip__3Iqb1.Tooltip_auto__cAwzz .Tooltip_dangerTooltip__8v5gt {
    visibility: hidden;
    opacity: 0;
}

.Tooltip_tooltip__3Iqb1.Tooltip_auto__cAwzz:hover .Tooltip_tooltiptext__naU\\+G,
.Tooltip_tooltip__3Iqb1.Tooltip_auto__cAwzz:hover .Tooltip_dangerTooltip__8v5gt {
    visibility: visible;
    opacity: 1;
}

/* Underline Style */
.Tooltip_dotted__DKpLo {
    margin-left: 5px;
    margin-right: 5px;
    border-bottom: 1px dotted var(--color-100);
}

/** Tooltip Top **/
.Tooltip_tooltip__3Iqb1 .Tooltip_top__A78TR.Tooltip_tooltiptext__naU\\+G, .Tooltip_tooltip__3Iqb1 .Tooltip_top__A78TR.Tooltip_dangerTooltip__8v5gt {
    position: absolute;
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
}

.Tooltip_tooltip__3Iqb1 .Tooltip_top__A78TR.Tooltip_tooltiptext__naU\\+G::after, .Tooltip_tooltip__3Iqb1 .Tooltip_top__A78TR.Tooltip_dangerTooltip__8v5gt::after {
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_top__A78TR.Tooltip_tooltiptext__naU\\+G::after {
    border-color: var(--color-120) transparent transparent transparent;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_top__A78TR.Tooltip_dangerTooltip__8v5gt::after {
    border-color: var(--color-red-primary) transparent transparent transparent;
}

/** Tooltip Top Right **/
.Tooltip_tooltip__3Iqb1 .Tooltip_topRight__d-x3i.Tooltip_tooltiptext__naU\\+G, .Tooltip_tooltip__3Iqb1 .Tooltip_topRight__d-x3i.Tooltip_dangerTooltip__8v5gt {
    position: absolute;
    bottom: calc(100% + 10px);
    right: 0;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_topRight__d-x3i.Tooltip_tooltiptext__naU\\+G::after, .Tooltip_tooltip__3Iqb1 .Tooltip_topRight__d-x3i.Tooltip_dangerTooltip__8v5gt::after {
    position: absolute;
    top: 100%;
    right: 7px;
    margin-left: -5px;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_topRight__d-x3i.Tooltip_tooltiptext__naU\\+G::after {
    border-color: var(--color-120) transparent transparent transparent;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_topRight__d-x3i.Tooltip_dangerTooltip__8v5gt::after {
    border-color: var(--color-red-primary) transparent transparent transparent;
}

/** Tooltip Top Left **/
.Tooltip_tooltip__3Iqb1 .Tooltip_topLeft__70ToR.Tooltip_tooltiptext__naU\\+G, .Tooltip_tooltip__3Iqb1 .Tooltip_topLeft__70ToR.Tooltip_dangerTooltip__8v5gt {
    position: absolute;
    bottom: calc(100% + 10px);
    left: 0;
    margin-left: -5px;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_topLeft__70ToR.Tooltip_tooltiptext__naU\\+G::after, .Tooltip_tooltip__3Iqb1 .Tooltip_topLeft__70ToR.Tooltip_dangerTooltip__8v5gt::after {
    position: absolute;
    top: 100%;
    left: 7px;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_topLeft__70ToR.Tooltip_tooltiptext__naU\\+G::after {
    border-color: var(--color-120) transparent transparent transparent;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_topLeft__70ToR.Tooltip_dangerTooltip__8v5gt::after {
    border-color: var(--color-red-primary) transparent transparent transparent
}

/** Tooltip Right **/
.Tooltip_tooltip__3Iqb1 .Tooltip_right__12lnq.Tooltip_tooltiptext__naU\\+G, .Tooltip_tooltip__3Iqb1 .Tooltip_right__12lnq.Tooltip_dangerTooltip__8v5gt {
    position: absolute;
    left: calc(100% + 10px);
    top: 0;
    bottom: 0;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_right__12lnq.Tooltip_tooltiptext__naU\\+G::after, .Tooltip_tooltip__3Iqb1 .Tooltip_right__12lnq.Tooltip_dangerTooltip__8v5gt::after {
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -5px;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_right__12lnq.Tooltip_tooltiptext__naU\\+G::after {
    border-color: transparent var(--color-120) transparent transparent;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_right__12lnq.Tooltip_dangerTooltip__8v5gt::after {
    border-color: transparent var(--color-red-primary) transparent transparent;
}

/** Tooltip Left **/
.Tooltip_tooltip__3Iqb1 .Tooltip_left__ff\\+ay.Tooltip_tooltiptext__naU\\+G, .Tooltip_tooltip__3Iqb1 .Tooltip_left__ff\\+ay.Tooltip_dangerTooltip__8v5gt {
    position: absolute;
    right: calc(100% + 10px);
    top: 0;
    bottom: 0;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_left__ff\\+ay.Tooltip_tooltiptext__naU\\+G::after, .Tooltip_tooltip__3Iqb1 .Tooltip_left__ff\\+ay.Tooltip_dangerTooltip__8v5gt::after {
    position: absolute;
    top: 50%;
    left: 100%;
    margin-top: -5px;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_left__ff\\+ay.Tooltip_tooltiptext__naU\\+G::after {
    border-color: transparent transparent transparent var(--color-120);
}

.Tooltip_tooltip__3Iqb1 .Tooltip_left__ff\\+ay.Tooltip_dangerTooltip__8v5gt::after {
    border-color: transparent transparent transparent var(--color-red-primary);
}

/** Tooltip Bottom **/
.Tooltip_tooltip__3Iqb1 .Tooltip_bottom__6yswC.Tooltip_tooltiptext__naU\\+G, .Tooltip_tooltip__3Iqb1 .Tooltip_bottom__6yswC.Tooltip_dangerTooltip__8v5gt {
    position: absolute;
    top: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
}

.Tooltip_tooltip__3Iqb1 .Tooltip_bottom__6yswC.Tooltip_tooltiptext__naU\\+G::after, .Tooltip_tooltip__3Iqb1 .Tooltip_bottom__6yswC.Tooltip_dangerTooltip__8v5gt::after {
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;

}

.Tooltip_tooltip__3Iqb1 .Tooltip_bottom__6yswC.Tooltip_tooltiptext__naU\\+G::after {
    border-color: transparent transparent var(--color-120) transparent;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_bottom__6yswC.Tooltip_dangerTooltip__8v5gt::after {
    border-color: transparent transparent var(--color-red-primary) transparent;
}

/** Tooltip Bottom-Right **/
.Tooltip_tooltip__3Iqb1 .Tooltip_bottomRight__YZ8Zl.Tooltip_tooltiptext__naU\\+G, .Tooltip_tooltip__3Iqb1 .Tooltip_bottomRight__YZ8Zl.Tooltip_dangerTooltip__8v5gt {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_bottomRight__YZ8Zl.Tooltip_tooltiptext__naU\\+G::after, .Tooltip_tooltip__3Iqb1 .Tooltip_bottomRight__YZ8Zl.Tooltip_dangerTooltip__8v5gt::after {
    position: absolute;
    bottom: 100%;
    right: 7px;
    margin-left: -5px;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_bottomRight__YZ8Zl.Tooltip_tooltiptext__naU\\+G::after {
    border-color: transparent transparent var(--color-120) transparent;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_bottomRight__YZ8Zl.Tooltip_dangerTooltip__8v5gt::after {
    border-color: transparent transparent var(--color-red-primary) transparent;
}

/** Tooltip Bottom-Left **/
.Tooltip_tooltip__3Iqb1 .Tooltip_bottomLeft__azU9W.Tooltip_tooltiptext__naU\\+G, .Tooltip_tooltip__3Iqb1 .Tooltip_bottomLeft__azU9W.Tooltip_dangerTooltip__8v5gt {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    margin-left: -5px;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_bottomLeft__azU9W.Tooltip_tooltiptext__naU\\+G::after, .Tooltip_tooltip__3Iqb1 .Tooltip_bottomLeft__azU9W.Tooltip_dangerTooltip__8v5gt::after {
    position: absolute;
    bottom: 100%;
    left: 7px;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_bottomLeft__azU9W.Tooltip_tooltiptext__naU\\+G::after {
    border-color: transparent transparent var(--color-120) transparent;
}

.Tooltip_tooltip__3Iqb1 .Tooltip_bottomLeft__azU9W.Tooltip_dangerTooltip__8v5gt::after {
    border-color: transparent transparent var(--color-red-primary) transparent;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Tooltip/Tooltip.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,+EAA+E;IAC/E,eAAe;IACf,kBAAkB;IAClB,gBAAgB;;IAEhB,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;IAC1C,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,mBAAmB;IACnB,UAAU;AACd;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,0EAA0E;AAC9E;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,0EAA0E;AAC9E;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI;AACJ;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,uBAAuB;IACvB,MAAM;IACN,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,0EAA0E;AAC9E;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,wBAAwB;IACxB,MAAM;IACN,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,0EAA0E;AAC9E;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,iBAAiB;;AAErB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,0EAA0E;AAC9E;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,0EAA0E;AAC9E;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,sBAAsB;IACtB,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,0EAA0E;AAC9E","sourcesContent":[".show {\n    visibility: visible;\n    opacity: 1;\n}\n\n.hide {\n    visibility: hidden;\n    opacity: 0;\n}\n\n.tooltip {\n    position: relative;\n    display: inline-table;\n}\n\n.tooltip .tooltiptext,\n.tooltip .dangerTooltip {\n    width: max-content;\n    max-width: 250px;\n    font: 100 14px/22px 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-size: 13px;\n    border-radius: 2px;\n    line-height: 1.5;\n\n    text-align: center;\n    z-index: 40;\n    transition: opacity 0.3s;\n    margin-top: auto;\n    margin-bottom: auto;\n    display: inline-table;\n}\n\n.tooltip .tooltiptext::after,\n.tooltip .dangerTooltip::after {\n    content: \"\";\n    border-width: 5px;\n    border-style: solid;\n}\n\n.tooltip .tooltiptext {\n    background-color: var(--color-120);\n    color: var(--color-106);\n}\n\n.tooltip .dangerTooltip {\n    background-color: var(--color-red-primary);\n    color: var(--color-text-light);\n}\n\n.tooltip .tooltipContent {\n    padding: 7px 11px;\n}\n\n.tooltip.auto .tooltiptext,\n.tooltip.auto .dangerTooltip {\n    visibility: hidden;\n    opacity: 0;\n}\n\n.tooltip.auto:hover .tooltiptext,\n.tooltip.auto:hover .dangerTooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* Underline Style */\n.dotted {\n    margin-left: 5px;\n    margin-right: 5px;\n    border-bottom: 1px dotted var(--color-100);\n}\n\n/** Tooltip Top **/\n.tooltip .top.tooltiptext, .tooltip .top.dangerTooltip {\n    position: absolute;\n    bottom: calc(100% + 10px);\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.tooltip .top.tooltiptext::after, .tooltip .top.dangerTooltip::after {\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n}\n\n.tooltip .top.tooltiptext::after {\n    border-color: var(--color-120) transparent transparent transparent;\n}\n\n.tooltip .top.dangerTooltip::after {\n    border-color: var(--color-red-primary) transparent transparent transparent;\n}\n\n/** Tooltip Top Right **/\n.tooltip .topRight.tooltiptext, .tooltip .topRight.dangerTooltip {\n    position: absolute;\n    bottom: calc(100% + 10px);\n    right: 0;\n}\n\n.tooltip .topRight.tooltiptext::after, .tooltip .topRight.dangerTooltip::after {\n    position: absolute;\n    top: 100%;\n    right: 7px;\n    margin-left: -5px;\n}\n\n.tooltip .topRight.tooltiptext::after {\n    border-color: var(--color-120) transparent transparent transparent;\n}\n\n.tooltip .topRight.dangerTooltip::after {\n    border-color: var(--color-red-primary) transparent transparent transparent;\n}\n\n/** Tooltip Top Left **/\n.tooltip .topLeft.tooltiptext, .tooltip .topLeft.dangerTooltip {\n    position: absolute;\n    bottom: calc(100% + 10px);\n    left: 0;\n    margin-left: -5px;\n}\n\n.tooltip .topLeft.tooltiptext::after, .tooltip .topLeft.dangerTooltip::after {\n    position: absolute;\n    top: 100%;\n    left: 7px;\n}\n\n.tooltip .topLeft.tooltiptext::after {\n    border-color: var(--color-120) transparent transparent transparent;\n}\n\n.tooltip .topLeft.dangerTooltip::after {\n    border-color: var(--color-red-primary) transparent transparent transparent\n}\n\n/** Tooltip Right **/\n.tooltip .right.tooltiptext, .tooltip .right.dangerTooltip {\n    position: absolute;\n    left: calc(100% + 10px);\n    top: 0;\n    bottom: 0;\n}\n\n.tooltip .right.tooltiptext::after, .tooltip .right.dangerTooltip::after {\n    position: absolute;\n    top: 50%;\n    right: 100%;\n    margin-top: -5px;\n}\n\n.tooltip .right.tooltiptext::after {\n    border-color: transparent var(--color-120) transparent transparent;\n}\n\n.tooltip .right.dangerTooltip::after {\n    border-color: transparent var(--color-red-primary) transparent transparent;\n}\n\n/** Tooltip Left **/\n.tooltip .left.tooltiptext, .tooltip .left.dangerTooltip {\n    position: absolute;\n    right: calc(100% + 10px);\n    top: 0;\n    bottom: 0;\n}\n\n.tooltip .left.tooltiptext::after, .tooltip .left.dangerTooltip::after {\n    position: absolute;\n    top: 50%;\n    left: 100%;\n    margin-top: -5px;\n}\n\n.tooltip .left.tooltiptext::after {\n    border-color: transparent transparent transparent var(--color-120);\n}\n\n.tooltip .left.dangerTooltip::after {\n    border-color: transparent transparent transparent var(--color-red-primary);\n}\n\n/** Tooltip Bottom **/\n.tooltip .bottom.tooltiptext, .tooltip .bottom.dangerTooltip {\n    position: absolute;\n    top: calc(100% + 10px);\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.tooltip .bottom.tooltiptext::after, .tooltip .bottom.dangerTooltip::after {\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    margin-left: -5px;\n\n}\n\n.tooltip .bottom.tooltiptext::after {\n    border-color: transparent transparent var(--color-120) transparent;\n}\n\n.tooltip .bottom.dangerTooltip::after {\n    border-color: transparent transparent var(--color-red-primary) transparent;\n}\n\n/** Tooltip Bottom-Right **/\n.tooltip .bottomRight.tooltiptext, .tooltip .bottomRight.dangerTooltip {\n    position: absolute;\n    top: calc(100% + 10px);\n    right: 0;\n}\n\n.tooltip .bottomRight.tooltiptext::after, .tooltip .bottomRight.dangerTooltip::after {\n    position: absolute;\n    bottom: 100%;\n    right: 7px;\n    margin-left: -5px;\n}\n\n.tooltip .bottomRight.tooltiptext::after {\n    border-color: transparent transparent var(--color-120) transparent;\n}\n\n.tooltip .bottomRight.dangerTooltip::after {\n    border-color: transparent transparent var(--color-red-primary) transparent;\n}\n\n/** Tooltip Bottom-Left **/\n.tooltip .bottomLeft.tooltiptext, .tooltip .bottomLeft.dangerTooltip {\n    position: absolute;\n    top: calc(100% + 10px);\n    left: 0;\n    margin-left: -5px;\n}\n\n.tooltip .bottomLeft.tooltiptext::after, .tooltip .bottomLeft.dangerTooltip::after {\n    position: absolute;\n    bottom: 100%;\n    left: 7px;\n}\n\n.tooltip .bottomLeft.tooltiptext::after {\n    border-color: transparent transparent var(--color-120) transparent;\n}\n\n.tooltip .bottomLeft.dangerTooltip::after {\n    border-color: transparent transparent var(--color-red-primary) transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"show": `Tooltip_show__X1SxV`,
	"hide": `Tooltip_hide__UNidW`,
	"tooltip": `Tooltip_tooltip__3Iqb1`,
	"tooltiptext": `Tooltip_tooltiptext__naU+G`,
	"dangerTooltip": `Tooltip_dangerTooltip__8v5gt`,
	"tooltipContent": `Tooltip_tooltipContent__AfOac`,
	"auto": `Tooltip_auto__cAwzz`,
	"dotted": `Tooltip_dotted__DKpLo`,
	"top": `Tooltip_top__A78TR`,
	"topRight": `Tooltip_topRight__d-x3i`,
	"topLeft": `Tooltip_topLeft__70ToR`,
	"right": `Tooltip_right__12lnq`,
	"left": `Tooltip_left__ff+ay`,
	"bottom": `Tooltip_bottom__6yswC`,
	"bottomRight": `Tooltip_bottomRight__YZ8Zl`,
	"bottomLeft": `Tooltip_bottomLeft__azU9W`
};
export default ___CSS_LOADER_EXPORT___;
